import React from "react";
import {userHasAnyRole} from "../../../utils/SecurityUtils";
import * as PropTypes from "prop-types";
import {AnlagenHeader} from "./AnlagenHeader";
import {AnlagenEinleiter} from "./AnlagenEinleiter";
import {BEAUFTRAGTER, BETREIBER, FACHADMIN, SYSTEMADMIN, ZUST_SBD} from "../../../consts/funktionaleRollen";
import {getAbwasserartEndpoint, getKanalMaterialartEndpoint, getKanalsystemEndpoint,} from "../../../services/WertelistenService";
import {useHttpSortById} from "../../../utils/usePreformattedHttp";
import {KANALNETZ} from "../../../consts/anlagentyp";
import AnlagenFooter from "./AnlagenFooter";
import {useAnlagenstatus} from "../../../services/AnlagenService";
import {Typography} from "@material-ui/core";

export default function Kanalnetz(props) {
    const [anlagenstatusOptionen] = useAnlagenstatus(props.data?.anlagenart?.id, props.data?.anlagentyp?.id, props.betriebstyp?.id);
    const [abwasserartOptionen] = useHttpSortById(getAbwasserartEndpoint);
    const [materialartOptionen] = useHttpSortById(getKanalMaterialartEndpoint);
    const [kanalsystemOptionen] = useHttpSortById(getKanalsystemEndpoint);

    const abwasserbeseitigungspflichtige = props.data?.abwasserbeseitigungspflichtige ? props.data.abwasserbeseitigungspflichtige : [];

    function isDisabled() {
        if (!props.anlageId) return false;
        if (props.modus === "l") {
            return true;
        }
        if (props.modus === "s") {
            return !userHasAnyRole([FACHADMIN, SYSTEMADMIN, ZUST_SBD, BETREIBER, BEAUFTRAGTER]);
        }
        return true;
    }

    function isSelbstueberwachungspflichtDisabled() {
        if (!props.anlageId) return false;
        if (props.modus === "l") {
            return true;
        }
        if (props.modus === "s") {
            return !userHasAnyRole([FACHADMIN, SYSTEMADMIN, ZUST_SBD]);
        }
        return true;
    }

    return (
        <div className="gridl tabsheet-content-margin">
            <AnlagenHeader
                data={props.data}
                formFactory={props.formFactory}
                disabled={isDisabled()}
                statusDisabled={isDisabled()}
                anlagenstatusOptionen={anlagenstatusOptionen.data}
                angeschlosseneAnlage={props.data?.angeschlosseneAnlage}
                anlagenstatus={props.data?.anlagenstatus}
                biggerBezeichnung={true}
            />
            <div style={{paddingRight: "35px"}}>
                <AnlagenEinleiter
                    betriebsId={props.betriebsId}
                    anlageId={props.anlageId}
                    anlagentyp={KANALNETZ}
                    formFactory={props.formFactory}
                    disabled={isDisabled()}
                    onChange={props.onChange}
                    isButtonVisible={userHasAnyRole([ZUST_SBD, FACHADMIN, SYSTEMADMIN]) || (userHasAnyRole([BETREIBER]) && !props.anlageId)}
                    isIndirektDisabled={true}
                    indirekteinleiter={props.data.indirekteinleiter}
                    abwasserbeseitigungspflichtige={abwasserbeseitigungspflichtige}
                />
            </div>
            <div className="gridl"
                 style={{paddingTop: "var(--vertical-spacing)", gridTemplateColumns: "1fr 1fr 1fr 1fr"}}>
                <div style={{display: "flex", alignItems: "center"}}>
                    {props.formFactory.renderCheckbox("inWasserschutzgebiet", "inWasserschutzgebiet", "In Wasserschutzgebiet", isDisabled())}
                </div>
                <div style={{display: "grid", gridTemplateColumns: "15em 3em"}}>
                    {props.formFactory.renderNumberInput("kanallaenge", "kanallaenge", "Kanallänge gesamt", isDisabled())}
                    <Typography style={{
                        paddingLeft: "1em",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center"
                    }}>
                        km
                    </Typography>
                </div>
                <div style={{display: "flex", alignItems: "center"}}>
                    {props.formFactory.renderCheckbox(
                        "selbstueberwachungspflicht",
                        "selbstueberwachungspflicht",
                        "Selbstüberwachungspflicht",
                        isSelbstueberwachungspflichtDisabled())}
                </div>
                <div/>
                <div>
                    {props.formFactory.renderAutocompleteWerteliste(
                        "kanalsystem",
                        "kanalsystem",
                        "Kanalsystem",
                        kanalsystemOptionen,
                        false,
                        isDisabled()
                    )}
                </div>
                <div>
                    {props.formFactory.renderAutocompleteWerteliste(
                        "abwasserart",
                        "abwasserart",
                        "Abwasserart",
                        abwasserartOptionen,
                        false,
                        isDisabled()
                    )}
                </div>
                <div>
                    {props.formFactory.renderAutocompleteWerteliste(
                        "materialart",
                        "materialart",
                        "Materialart",
                        materialartOptionen,
                        false,
                        isDisabled()
                    )}
                </div>
                <div style={{gridColumnEnd: "span 4"}}>
                    <AnlagenFooter
                        formFactory={props.formFactory}
                        withAnlagenart={props.withAnlagenart}
                        withDwaAndStaLa={false}
                        isDisabled={isDisabled()}/>
                </div>
            </div>
        </div>
    );
}

Kanalnetz.propTypes = {
    anlageId: PropTypes.number,
    modus: PropTypes.oneOf(["l", "s"]).isRequired,
};
